import { cn } from "@/lib/utils"

/**
 * Lesefortschritt oben am Bildschirm. Rein in CSS über eine scroll-getriebene Animation
 * (.scroll-progress in src/styles.css), ohne JavaScript und ohne Neuzeichnen.
 * Browser ohne Unterstützung blenden den Balken aus.
 */
export function ScrollProgress({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("scroll-progress fixed inset-x-0 top-0 z-50 h-px origin-left", className)}
      aria-hidden="true"
      {...props}
    />
  )
}
